module.exports = __webpack_public_path__ + "60f28b849e0daab7f3739d117a7e673b.png";